import { render, staticRenderFns } from "./5.vue?vue&type=template&id=6c335684&scoped=true&"
var script = {}
import style0 from "./5.vue?vue&type=style&index=0&id=6c335684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c335684",
  null
  
)

export default component.exports